import { registerPlugin, WebPlugin } from "@capacitor/core";
import { Geolocation, Position } from "@capacitor/geolocation"

export interface GeolocationSopoPlugin {
  getLocation():  Promise<Position>;
}

export class GeolocationPlugin extends WebPlugin {

  constructor(
  ) {
    super();
  }

  public async getLocation(): Promise<Position> {
    return Geolocation.getCurrentPosition({enableHighAccuracy: true, 'maximumAge': 1});  
  }

}

const GeolocationSopoPlugin = registerPlugin<GeolocationSopoPlugin>('GeolocationSopoPlugin', {
    web: () => new GeolocationPlugin(),
  },
);

export default GeolocationSopoPlugin;
